module.exports = __webpack_public_path__ + "img/img_assistant_img4.a8c96f7a.png";